import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Shop from '@/components/Shop'
import Product from '@/components/Product'
import Blog from '@/components/Blog'
import Post from '@/components/Post'
import Cart from '@/components/Cart'
import Layout from '@/components/Layout'
import Comunidad from '@/components/Comunidad'
import Invitados from '@/components/Invitados'
import Edicionespasadas from '@/components/Edicionespasadas'
import Miembros from '@/components/Miembros'
import Llamado from '@/components/Llamado'
import Podcast from '@/components/Podcast'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: Layout,
      children:[
        {
          path:'/',
          component:Home,
          name:''
        },
        {
          path:'/podcast',
          component:Podcast,
          name:'Podcast'
        },
        {
          path:'/miembros',
          component:Miembros,
          name:'Miembros'
        },
        {
          path:'/invitados',
          component:Invitados,
          name:'Invitados'
        },
        {
          path:'/edicionespasadas',
          component:Edicionespasadas,
          name:'Ediciones pasadas'
        },
        {
          path:'/comunidad',
          component:Comunidad,
          name:'La Comunidad'
        },
        {
          path:'/llamado',
          component:Llamado,
          name:'Llamado a obras'
        },
        {
          path:'/shop',
          component:Shop,
          name:'Shop'
        },
        {
          path:'/product',
          component:Product,
          name:'Product'
        },
        {
          path:'/blog',
          component:Blog,
          name:'Blog'
        },
        {
          path:'/post',
          component:Post,
          name:'Post'
        },
        {
          path:'/comunicado',
          component:Home,
          name:'Comunicado'
        }
      ]

    }
  ],
    mode:'history'
},

  )



// WEBPACK FOOTER //
// ./src/router/index.js